import { Phone, User } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import type { CampaignContact } from '../../api/campaigns'
import { formatPhone } from '../../lib/utils'

interface CampaignContactCardProps {
  contact: CampaignContact
  index: number
  total: number
}

export function CampaignContactCard({ contact, index, total }: CampaignContactCardProps) {
  const { t } = useTranslation('campaigns')
  return (
    <div className="rounded-lg border border-border bg-surface-card p-5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-primary/10">
            <User className="h-5 w-5 text-primary" />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-text-primary">
              {contact.name || t('runner.unknown')}
            </h3>
            <p className="flex items-center gap-1.5 font-mono text-sm text-text-secondary">
              <Phone className="h-3.5 w-3.5" />
              {formatPhone(contact.phone)}
            </p>
          </div>
        </div>
        <span className="rounded-full bg-surface-elevated px-3 py-1 text-xs font-medium text-text-muted">
          {t('simulations:runner.indexOfTotal', { index, total })}
        </span>
      </div>
    </div>
  )
}
